export default "__VITE_ASSET__dde12443__"